/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.168.0-SNAPSHOT
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorRest } from '../models';
// @ts-ignore
import type { WhitelistTerminRest } from '../models';
// @ts-ignore
import type { WhitelistTerminSerieRest } from '../models';
/**
 * WhitelistResourceApi - axios parameter creator
 * @export
 */
export const WhitelistResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Termin über die Angabe eine ID in der Whitelist gelöscht.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der Termine in der Whitelist löscht.
         * @param {Array<number>} requestBody ID der Termine die gelöscht werden sollen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelist: async (requestBody: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deleteWhitelist', 'requestBody', requestBody)
            const localVarPath = `/konfigurationen/whitelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Termin-Serie aus der Whitelist gelöscht.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Löschen einer Termin-Serie aus der Whitelist.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelistSerie: async (zustaendigkeit: string, sitzungscode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zustaendigkeit' is not null or undefined
            assertParamExists('deleteWhitelistSerie', 'zustaendigkeit', zustaendigkeit)
            // verify required parameter 'sitzungscode' is not null or undefined
            assertParamExists('deleteWhitelistSerie', 'sitzungscode', sitzungscode)
            const localVarPath = `/konfigurationen/whitelistserie/zustaendigkeit/{zustaendigkeit}/sitzungscode/{sitzungscode}`
                .replace(`{${"zustaendigkeit"}}`, encodeURIComponent(String(zustaendigkeit)))
                .replace(`{${"sitzungscode"}}`, encodeURIComponent(String(sitzungscode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Termin-Serie aus der Whitelist als Datei heruntergeladen.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt zum Herunterladen einer Termin-Serie aus der Whitelist.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadWhitelistSerie: async (zustaendigkeit: string, sitzungscode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zustaendigkeit' is not null or undefined
            assertParamExists('downloadWhitelistSerie', 'zustaendigkeit', zustaendigkeit)
            // verify required parameter 'sitzungscode' is not null or undefined
            assertParamExists('downloadWhitelistSerie', 'sitzungscode', sitzungscode)
            const localVarPath = `/konfigurationen/whitelistserie/zustaendigkeit/{zustaendigkeit}/sitzungscode/{sitzungscode}/datei`
                .replace(`{${"zustaendigkeit"}}`, encodeURIComponent(String(zustaendigkeit)))
                .replace(`{${"sitzungscode"}}`, encodeURIComponent(String(sitzungscode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der alle Termine der Whitelist ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelist: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/konfigurationen/whitelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit ausliefert.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistByZustaendigkeit: async (zustaendigkeit: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zustaendigkeit' is not null or undefined
            assertParamExists('getWhitelistByZustaendigkeit', 'zustaendigkeit', zustaendigkeit)
            const localVarPath = `/konfigurationen/whitelist/zustaendigkeit/{zustaendigkeit}`
                .replace(`{${"zustaendigkeit"}}`, encodeURIComponent(String(zustaendigkeit)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit und Sitzung ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit und der Sitzung ausliefert.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistByZustaendigkeitBySitzungscode: async (zustaendigkeit: string, sitzungscode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zustaendigkeit' is not null or undefined
            assertParamExists('getWhitelistByZustaendigkeitBySitzungscode', 'zustaendigkeit', zustaendigkeit)
            // verify required parameter 'sitzungscode' is not null or undefined
            assertParamExists('getWhitelistByZustaendigkeitBySitzungscode', 'sitzungscode', sitzungscode)
            const localVarPath = `/konfigurationen/whitelist/zustaendigkeit/{zustaendigkeit}/sitzungscode/{sitzungscode}`
                .replace(`{${"zustaendigkeit"}}`, encodeURIComponent(String(zustaendigkeit)))
                .replace(`{${"sitzungscode"}}`, encodeURIComponent(String(sitzungscode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Termin-Serien aus der Whitelist ausgeliefert.<br> Sie werden gruppiert nach Zuständigkeit und Sitzungscode.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der Termin-Serien aus der Whitelist ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistSerie: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/konfigurationen/whitelistserie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird die Whitelist aktualisiert.<br> Achtung: vorhandene Termine bleiben erhalten.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der die Whitelist aktualisiert.
         * @param {File} whitelist Datei mit Terminen für die Whitelist
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWhitelist: async (whitelist: File, zustaendigkeit: string, sitzungscode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'whitelist' is not null or undefined
            assertParamExists('uploadWhitelist', 'whitelist', whitelist)
            // verify required parameter 'zustaendigkeit' is not null or undefined
            assertParamExists('uploadWhitelist', 'zustaendigkeit', zustaendigkeit)
            // verify required parameter 'sitzungscode' is not null or undefined
            assertParamExists('uploadWhitelist', 'sitzungscode', sitzungscode)
            const localVarPath = `/konfigurationen/whitelist/upload/zustaendigkeit/{zustaendigkeit}/sitzungscode/{sitzungscode}`
                .replace(`{${"zustaendigkeit"}}`, encodeURIComponent(String(zustaendigkeit)))
                .replace(`{${"sitzungscode"}}`, encodeURIComponent(String(sitzungscode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (whitelist !== undefined) { 
                localVarFormParams.append('whitelist', whitelist as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhitelistResourceApi - functional programming interface
 * @export
 */
export const WhitelistResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhitelistResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Termin über die Angabe eine ID in der Whitelist gelöscht.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der Termine in der Whitelist löscht.
         * @param {Array<number>} requestBody ID der Termine die gelöscht werden sollen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWhitelist(requestBody: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWhitelist(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhitelistResourceApi.deleteWhitelist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Termin-Serie aus der Whitelist gelöscht.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Löschen einer Termin-Serie aus der Whitelist.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWhitelistSerie(zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWhitelistSerie(zustaendigkeit, sitzungscode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhitelistResourceApi.deleteWhitelistSerie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Termin-Serie aus der Whitelist als Datei heruntergeladen.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt zum Herunterladen einer Termin-Serie aus der Whitelist.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadWhitelistSerie(zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadWhitelistSerie(zustaendigkeit, sitzungscode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhitelistResourceApi.downloadWhitelistSerie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der alle Termine der Whitelist ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhitelist(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WhitelistTerminRest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhitelist(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhitelistResourceApi.getWhitelist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit ausliefert.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhitelistByZustaendigkeit(zustaendigkeit: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WhitelistTerminRest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhitelistByZustaendigkeit(zustaendigkeit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhitelistResourceApi.getWhitelistByZustaendigkeit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit und Sitzung ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit und der Sitzung ausliefert.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhitelistByZustaendigkeitBySitzungscode(zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WhitelistTerminRest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhitelistByZustaendigkeitBySitzungscode(zustaendigkeit, sitzungscode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhitelistResourceApi.getWhitelistByZustaendigkeitBySitzungscode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Termin-Serien aus der Whitelist ausgeliefert.<br> Sie werden gruppiert nach Zuständigkeit und Sitzungscode.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der Termin-Serien aus der Whitelist ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhitelistSerie(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WhitelistTerminSerieRest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhitelistSerie(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhitelistResourceApi.getWhitelistSerie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird die Whitelist aktualisiert.<br> Achtung: vorhandene Termine bleiben erhalten.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der die Whitelist aktualisiert.
         * @param {File} whitelist Datei mit Terminen für die Whitelist
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadWhitelist(whitelist: File, zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadWhitelist(whitelist, zustaendigkeit, sitzungscode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhitelistResourceApi.uploadWhitelist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WhitelistResourceApi - factory interface
 * @export
 */
export const WhitelistResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhitelistResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Termin über die Angabe eine ID in der Whitelist gelöscht.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der Termine in der Whitelist löscht.
         * @param {Array<number>} requestBody ID der Termine die gelöscht werden sollen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelist(requestBody: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWhitelist(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Termin-Serie aus der Whitelist gelöscht.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Löschen einer Termin-Serie aus der Whitelist.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelistSerie(zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWhitelistSerie(zustaendigkeit, sitzungscode, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Termin-Serie aus der Whitelist als Datei heruntergeladen.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt zum Herunterladen einer Termin-Serie aus der Whitelist.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadWhitelistSerie(zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadWhitelistSerie(zustaendigkeit, sitzungscode, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der alle Termine der Whitelist ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelist(options?: RawAxiosRequestConfig): AxiosPromise<Array<WhitelistTerminRest>> {
            return localVarFp.getWhitelist(options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit ausliefert.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistByZustaendigkeit(zustaendigkeit: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WhitelistTerminRest>> {
            return localVarFp.getWhitelistByZustaendigkeit(zustaendigkeit, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit und Sitzung ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit und der Sitzung ausliefert.
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistByZustaendigkeitBySitzungscode(zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WhitelistTerminRest>> {
            return localVarFp.getWhitelistByZustaendigkeitBySitzungscode(zustaendigkeit, sitzungscode, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Termin-Serien aus der Whitelist ausgeliefert.<br> Sie werden gruppiert nach Zuständigkeit und Sitzungscode.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt der Termin-Serien aus der Whitelist ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistSerie(options?: RawAxiosRequestConfig): AxiosPromise<Array<WhitelistTerminSerieRest>> {
            return localVarFp.getWhitelistSerie(options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird die Whitelist aktualisiert.<br> Achtung: vorhandene Termine bleiben erhalten.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der die Whitelist aktualisiert.
         * @param {File} whitelist Datei mit Terminen für die Whitelist
         * @param {string} zustaendigkeit Zuständigkeit
         * @param {string} sitzungscode Sitzung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWhitelist(whitelist: File, zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadWhitelist(whitelist, zustaendigkeit, sitzungscode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhitelistResourceApi - object-oriented interface
 * @export
 * @class WhitelistResourceApi
 * @extends {BaseAPI}
 */
export class WhitelistResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Termin über die Angabe eine ID in der Whitelist gelöscht.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt der Termine in der Whitelist löscht.
     * @param {Array<number>} requestBody ID der Termine die gelöscht werden sollen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistResourceApi
     */
    public deleteWhitelist(requestBody: Array<number>, options?: RawAxiosRequestConfig) {
        return WhitelistResourceApiFp(this.configuration).deleteWhitelist(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Termin-Serie aus der Whitelist gelöscht.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt zum Löschen einer Termin-Serie aus der Whitelist.
     * @param {string} zustaendigkeit Zuständigkeit
     * @param {string} sitzungscode Sitzung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistResourceApi
     */
    public deleteWhitelistSerie(zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig) {
        return WhitelistResourceApiFp(this.configuration).deleteWhitelistSerie(zustaendigkeit, sitzungscode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine Termin-Serie aus der Whitelist als Datei heruntergeladen.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
     * @summary Endpunkt zum Herunterladen einer Termin-Serie aus der Whitelist.
     * @param {string} zustaendigkeit Zuständigkeit
     * @param {string} sitzungscode Sitzung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistResourceApi
     */
    public downloadWhitelistSerie(zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig) {
        return WhitelistResourceApiFp(this.configuration).downloadWhitelistSerie(zustaendigkeit, sitzungscode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
     * @summary Endpunkt der alle Termine der Whitelist ausliefert.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistResourceApi
     */
    public getWhitelist(options?: RawAxiosRequestConfig) {
        return WhitelistResourceApiFp(this.configuration).getWhitelist(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
     * @summary Endpunkt der alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit ausliefert.
     * @param {string} zustaendigkeit Zuständigkeit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistResourceApi
     */
    public getWhitelistByZustaendigkeit(zustaendigkeit: string, options?: RawAxiosRequestConfig) {
        return WhitelistResourceApiFp(this.configuration).getWhitelistByZustaendigkeit(zustaendigkeit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit und Sitzung ausgeliefert.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
     * @summary Endpunkt der alle Termine der Whitelist unter Berücksichtigung der Zuständigkeit und der Sitzung ausliefert.
     * @param {string} zustaendigkeit Zuständigkeit
     * @param {string} sitzungscode Sitzung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistResourceApi
     */
    public getWhitelistByZustaendigkeitBySitzungscode(zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig) {
        return WhitelistResourceApiFp(this.configuration).getWhitelistByZustaendigkeitBySitzungscode(zustaendigkeit, sitzungscode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Termin-Serien aus der Whitelist ausgeliefert.<br> Sie werden gruppiert nach Zuständigkeit und Sitzungscode.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
     * @summary Endpunkt der Termin-Serien aus der Whitelist ausliefert.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistResourceApi
     */
    public getWhitelistSerie(options?: RawAxiosRequestConfig) {
        return WhitelistResourceApiFp(this.configuration).getWhitelistSerie(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird die Whitelist aktualisiert.<br> Achtung: vorhandene Termine bleiben erhalten.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt der die Whitelist aktualisiert.
     * @param {File} whitelist Datei mit Terminen für die Whitelist
     * @param {string} zustaendigkeit Zuständigkeit
     * @param {string} sitzungscode Sitzung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistResourceApi
     */
    public uploadWhitelist(whitelist: File, zustaendigkeit: string, sitzungscode: string, options?: RawAxiosRequestConfig) {
        return WhitelistResourceApiFp(this.configuration).uploadWhitelist(whitelist, zustaendigkeit, sitzungscode, options).then((request) => request(this.axios, this.basePath));
    }
}

